<template>
  <footer class="footer">
    <!--
    <div class="newsletter-cta">
      <div class="container">
        <div class="cta-content">
          <h2>Get the latest listings first</h2>
          <p>Sign up to receive daily updates on new homes in the GTA.</p>
        </div>
        <form @submit.prevent="handleSubscribe" class="cta-form">
          <input
            type="email"
            placeholder="Enter your email"
            required
            class="cta-input"
          />
          <button type="submit" class="cta-button">SUBSCRIBE</button>
        </form>
      </div>
    </div>
    -->

    <div class="footer-main">
      <div class="container footer-grid">
        <div class="footer-col">
          <h3 class="footer-logo">CLIENT'S <span>PREFERRED</span></h3>
          <p class="brand-desc">
            Your trusted partner in navigating the Greater Chandigarh real
            estate market. Providing excellence from consultation to closing.
          </p>
          <div class="social-links">
            <a
              href="https://www.facebook.com/clients.preferred.property.hub/"
              target="_blank"
              aria-label="Facebook"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/clientspreferredpropertyhub/"
              target="_blank"
              aria-label="Instagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path
                  d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                ></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@ClientsPreferredPropertyHub"
              target="_blank"
              aria-label="YouTube"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                ></path>
                <polygon
                  points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                ></polygon>
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-col">
          <h4>Navigation</h4>
          <ul class="footer-links">
            <li><router-link to="/">Home</router-link></li>
            <li>
              <router-link to="/associatedbuilders">Builders</router-link>
            </li>
            <li><router-link to="/buyer">Buyer</router-link></li>
            <li><router-link to="/about">The Visionaries</router-link></li>
            <li><router-link to="/contactus">Contact Us</router-link></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Contact Us</h4>
          <div class="contact-info">
            <a href="tel:+917087931778" class="contact-item link-item">
              <div class="icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
              </div>
              <div class="details">
                <small>Call Us</small>
                <p>+91-70879 31778</p>
              </div>
            </a>

            <a
              href="mailto:clientspreferredpropertyhub@gmail.com"
              class="contact-item link-item"
            >
              <div class="icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  ></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div class="details">
                <small>Email</small>
                <p>clientspreferredpropertyhub@gmail.com</p>
              </div>
            </a>

            <a
              href="https://www.google.com/maps/search/Gillco+Valley+Sector-127,+Kharar,+Mohali"
              target="_blank"
              class="contact-item link-item"
            >
              <div class="icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div class="details">
                <small>Visit Us</small>
                <p>Gillco Valley Sector-127, Kharar, Mohali</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <p>© 2026 Vipandeep Singh</p>
        <p class="disclaimer">
          All information is deemed reliable but not guaranteed.
        </p>
        <ul class="legal-links">
          <li>
            <router-link to="/privacy-policy">Privacy Policy</router-link>
          </li>
          <li>
            <router-link to="/cookie-policy">Cookie Policy</router-link>
          </li>
          <li>
            <button type="button" class="cookie-settings-btn"
              @click="openCookiePreferences">
              Cookie settings
            </button>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { openCookiePreferences } from '@/utils/consent';

/*
const handleSubscribe = () => {
  alert("Thank you for subscribing! You'll receive updates soon.");
};
*/
</script>

<style scoped>
.footer {
  background: #111111;
  color: #ffffff;
  margin-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Newsletter Section */
.newsletter-cta {
  background: #b91c1c;
  padding: 50px 0;
  text-align: center;
}

.newsletter-cta .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.cta-content h2 {
  font-size: 2rem;
  margin-bottom: 5px;
  font-weight: 800;
}

.cta-form {
  display: flex;
  width: 100%;
  max-width: 500px;
  gap: 10px;
}

.cta-input {
  flex-grow: 1;
  padding: 15px;
  border-radius: 4px;
  border: none;
  outline: none;
  font-size: 1rem;
}

.cta-button {
  background: #111;
  color: white;
  padding: 0 25px;
  border-radius: 4px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  white-space: nowrap;
}

.cta-button:hover {
  background: #333;
}

/* Footer Main */
.footer-main {
  padding: 70px 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.5fr;
  gap: 50px;
}

.footer-logo {
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-weight: 800;
}

.footer-logo span {
  color: #b91c1c;
}

.brand-desc {
  color: #999;
  line-height: 1.6;
  font-size: 0.95rem;
  margin-bottom: 20px;
}

/* Social Links Styling */
.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  color: #fffdfd;
  background: #b91c1c;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.social-links a:hover {
  background: #600606;
  color: #ffffff;
  transform: translateY(-3px);
}

.footer-col h4 {
  margin-bottom: 30px;
  font-size: 1.1rem;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-col h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 40px;
  height: 2px;
  background: #b91c1c;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
  font-size: 0.95rem;
}

.footer-links a:hover {
  color: #b91c1c;
}

/* Contact Info Styling */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  text-align: left;
  text-decoration: none;
}

.link-item {
  transition: transform 0.2s;
}

.link-item:hover {
  transform: translateX(5px);
}

.link-item:hover p {
  color: #ffffff;
}

.icon-wrapper {
  background: rgba(185, 28, 28, 0.1);
  color: #b91c1c;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-item .details {
  display: flex;
  flex-direction: column;
}

.contact-item small {
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 1px;
  color: #666;
  margin-bottom: 2px;
  font-weight: 700;
}

.contact-item p {
  color: #999;
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
  transition: color 0.3s;
}

/* Bottom Bar */
.footer-bottom {
  background: #000;
  padding: 25px 0;
  text-align: center;
  font-size: 0.8rem;
  color: #555;
  border-top: 1px solid #222;
}

.disclaimer {
  margin-top: 5px;
}

.legal-links {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 22px;
  margin: 14px 0 0;
  padding: 0;
}

.legal-links a,
.cookie-settings-btn {
  color: #777;
  font-size: 0.8rem;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.2s ease;
}

.legal-links a:hover,
.cookie-settings-btn:hover {
  color: #b91c1c;
}

/* Responsive */
@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  .footer-col:first-child {
    grid-column: span 2;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 20px auto;
  }
  .social-links {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 50px;
  }

  .footer-col h4::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .contact-info {
    align-items: center;
  }

  .contact-item {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    text-align: left;
  }

  .link-item:hover {
    transform: none;
  }

  .footer-links {
    display: inline-block;
    text-align: center;
  }

  .cta-form {
    flex-direction: column;
    gap: 15px;
  }

  .cta-button {
    padding: 15px;
    width: 100%;
  }
}
</style>
